import { render } from "./CardGoal.vue?vue&type=template&id=18d6fade"
import script from "./CardGoal.vue?vue&type=script&lang=js"
export * from "./CardGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__